export const LOAD_LIVE_FEED = 'LiveFeed/LOAD_LIVE_FEED';
export const LIVE_FEED_VISIT = 'LiveFeed/LIVE_FEED_VISIT';
export const NAMESPACE = 'LiveFeed';
